export const roundDecimals = (number: number | undefined | null, count: number = 0): number | null => {
  if (typeof number !== 'number') return null;

  if (count === 0) return Math.round(number);

  return parseFloat(number.toFixed(count));
};
